import styled from "styled-components";
import {ButtonLabelDefaultBox} from "./button-label.default.box";

export const ButtonLabelMrGreenBox = styled(ButtonLabelDefaultBox)`
    /** I have to do this because &::first-letter works only with block-level elements,  */
    /** https://developer.mozilla.org/en-US/docs/Web/CSS/::first-letter */
    display: inline-block;
    /**
        we must do the lowercase and then only first letter upper case because the translations is all upper case
        it's known issue that if the translation have 2 words for example: log in it will be Log in and not Log In
    **/
    text-transform: lowercase;
    
    &::first-letter {
        text-transform: uppercase;
    }
`;